import { useGetIntegrationAuthSchemes } from 'api';

import { useOrganisationId } from 'hooks/context';

import type { AuthenticationKeyFilter } from '../Authentication/types';

export const useAuthenticationKeys = (
  filter: AuthenticationKeyFilter = 'all'
) => {
  const organisationId = useOrganisationId<number>();
  const params =
    filter === 'all' ? undefined : { 'filter[enabled]': filter === 'enabled' };

  const { data, isLoading, isError } = useGetIntegrationAuthSchemes(
    organisationId,
    params
  );

  return { keys: data?.data ?? [], isLoading, isError };
};
